import { normalize } from 'normalizr'
import { Schemas } from '../../../shared/redux/schema'
import { updateEntities, deleteEntity } from '../../../shared/redux/entity'
import { encodeParams } from '../../../shared/functions/utilities'

const FETCH_REQUEST = 'realhub/providerAccount/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/providerAccount/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/providerAccount/FETCH_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  errors: []
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loading: true
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    loading: false,
    loaded: true,
    errors: [],
    result: payload.result
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    loaded: false,
    loading: false,
    errors: errors
  }
}

// Action Creators
export function loadProviderAccounts(options){
  let config = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    }
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(fetchRequest());

    // Encode Params
    let params = options ? `?${encodeParams(options)}` : '';
    let promise = fetch(`/agency/provider_accounts.json${params}`, config)
      .then(response => {
        return response.json().then( json => ({ json, response }) )
      })
      .then(({ json, response}) => {
        if(!response.ok){
          return Promise.reject(json);
        }

        let normalizedJson = normalize(json, Schemas.PROVIDER_ACCOUNT_ARRAY);
        dispatch(updateEntities(normalizedJson));
        dispatch(fetchSuccess({ result: normalizedJson.result }));
      })
      .catch(json => {
        console.log(json)
        let errors = json.errors ? json.errors : ["Something went wrong"];
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch(action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result: action.result,
        errors: []
      });
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors
      });
    default:
      return state;
  }
}